module.exports = __webpack_public_path__ + "static/img/Icon1.e83e44a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Icon1.png
// module id = nnxP
// module chunks = 7